export const text = {
  MyDevelopment: "My Development",
  AssignGoalToTeamaddedsuccessfully: "Assign Goal To Team added successfully!",
  AssignGoalToTeamupdatedsuccessfully:
    "Assign Goal To Team updated successfully!",
  AssignGoalToTeamDeletedsuccessfully:
    "Assign Goal To Team Deleted successfully!",
  Blogaddedsuccessfully: "Blog added successfully!",
  Blogupdatedsuccessfully: "Blog updated successfully!",
  BlogDeletedsuccessfully: "Blog deleted successfully!",
  MyDevelopmentGoaladdedsuccessfully: "My Development Goal added successfully!",
  MyDevelopmentGoalupdatedsuccessfully:
    "My Development Goal updated successfully!",
  MyDevelopmentGoalDeletedsuccessfully:
    "My Development Goal Deleted successfully!",
  GoalTitle: "Goal Title",
  StartDate: "Start Date",
  EndDate: "End Date",
  SubTitle: "Sub Title",
  Author: "Author",
  AddMyDevelopmentGoal: "Add My Development Goal",
  AddAssignGoalToTeam: "Add Assign Goal To Team",
  AddMyDevelopmentBlog: "Add My Development Blog",
  AddMyDevelopmentForm: "Add My Development Form",
  MyDevelopmentGoal: "My Development Goal",
  AssignGoalToTeam: "Assign Goal To Team",
  MyDevelopmentBlog: "My Development Blog",
  MyDevelopmentForm: "My Development Form",
};
